import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./index.module.scss";

export default function DetailsAppearanceDamage() {
  document.title = "车辆情况";

  const [preview, setPreview] = useState(false);
  const [damageLevel, setDamageLevel] = useState<any>(null);

  // 获取路由跳转传递的参数
  const { state } = useLocation<any>();
  console.log(state, 'state');
  

  useEffect(() => {
    console.log(state, 'state');
    const formatterLevel = () => {
      let str = "";
      state.damageLevel.split(",").forEach((item) => {
        switch (item) {
          case "1":
            str += "凹凸;";
            break;
          case "2":
            str += "划痕;";
            break;
          case "3":
            str += "损坏;";
            break;
          case "4":
            str += "破损;";
            break;
          case "5":
            str += "污渍;";
            break;
        }
      });
      setDamageLevel(str);
    };
    if(state.damageLevel) {
      formatterLevel();
    }
  }, [state.damageLevel]);

  const damageImg = (
    <div
      className={styles.damageImg}
      onClick={() => {
        setPreview(true);
      }}
    >
      <img src={state.url} alt="" />
    </div>
  );

  const damageInformation = state.type === '1' ? (
    <div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>损伤部位</span>
        <span className={styles.messageRight}>{state.part}</span>
      </div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>损伤情况</span>
        <span className={styles.messageRight}>{damageLevel}</span>
      </div>
    </div>
  ) : null;

  const content = state.type === '2' ? (
    <div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>加改装内容</span>
        <span className={styles.messageRight}>{state.content}</span>
      </div>
    </div>
  ) : null;

  const imgName = state.type === '3' ? (
    <div>
      <div className={styles.message}>
        <span className={styles.attachmentLeft}>附件名称</span>
        <span className={styles.attachmentRight}>{state.name}</span>
      </div>
    </div>
  ) : null;

  const remarksResults =
    state.remark !== "" && state.type !== '3' ? (
      <div className={styles.vehicle}>
        <p className={styles.title}>备注</p>
        <div className={styles.remarks}>{state.remark}</div>
      </div>
    ) : null;

  // 预览图片
  const previewImage = preview ? (
    <div>
      <div className={styles.mask}></div>
      <div
        className={styles.imagePreview}
        onClick={() => {
          setPreview(false);
        }}
      >
        <div className={styles.imagePreviewSwipe}>
          <div className={styles.swipeItem}>
            <div className={styles.itemImage}>
              <img className={styles.imgs} src={state.url} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;

  const pageContainerClass = `${styles.detailPageWrapper}`;

  return (
    <div className={pageContainerClass}>
      {damageImg}
      {damageInformation}
      {content}
      {imgName}
      {remarksResults}
      {previewImage}
    </div>
  );
}
